import React from 'react';

export default class FlowComponentHeader extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { component } = this.props;
        const { name, id, metadata } = component;
        const { title, intro } = metadata;

        return (
            <div className={`col col--flow-component-${name}`}>
                {title && (
                    <p className={`flow__header-title flow__header-title--${id}`}>
                        {title}
                    </p>
                )}
                {intro && (
                    <p className={`flow__header-intro flow__header-intro--${id}`}>
                        {intro}
                    </p>
                )}
            </div>
        );
    }
}
